"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ElstrLanguageService_1 = __importDefault(require("./services/ElstrLanguageService"));
var ElstrLanguageService_2 = __importDefault(require("./services/be2/ElstrLanguageService"));
var ElstrApplicationData_1 = require("./ElstrApplicationData");
var ElstrBaseApp_1 = __importDefault(require("./ElstrBaseApp"));
var BackendVersion_1 = require("./constants/BackendVersion");
var xss_1 = require("xss");
function convertUnicode(input) {
    return input.replace(/\\u(\w\w\w\w)/g, function (a, b) {
        var charcode = parseInt(b, 16);
        return String.fromCharCode(charcode);
    });
}
function finishDic(translatedString) {
    // convert unicode with convertUnicode
    // sanitizing translation-strings with filterXSS
    return xss_1.filterXSS(convertUnicode(translatedString));
}
/**
 * Used to translate a given key
 * Will return the key when the current translations object doesn't have they key
 * Optional replacer arguments can be provided to replace %s in translation, converted to a string
 */
function dic(key) {
    var replacer = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        replacer[_i - 1] = arguments[_i];
    }
    try {
        if (ElstrLanguage.getTranslations()[key] && replacer.length === 0) {
            return finishDic(ElstrLanguage.getTranslations()[key]);
        }
        if (ElstrLanguage.getTranslations()[key] && replacer.length >= 1) {
            var originalTranslation = ElstrLanguage.getTranslations()[key];
            if (originalTranslation.split("%s").length === 1) {
                // no %s in the text
                return originalTranslation;
            }
            var replacedTranslation_1 = originalTranslation;
            replacer.forEach(function (fragment) {
                replacedTranslation_1 = replacedTranslation_1.replace("%s", fragment);
            });
            return finishDic(replacedTranslation_1);
        }
        if (ElstrLanguage.showErrors) {
            console.warn("Translation-Key (" + key + ") not found in dictionary within language (" + ElstrLanguage.activeLang + ")");
        }
    }
    catch (e) {
        console.error(e);
    }
    return key;
}
exports.dic = dic;
/**
 * Short function to return the active language
 * @return {string}
 */
function activeLang() {
    return ElstrLanguage.activeLang;
}
exports.activeLang = activeLang;
/**
 * Short function to return the set active language
 */
function setActiveLang(lang) {
    ElstrLanguage.setActiveLang(lang).then();
}
exports.setActiveLang = setActiveLang;
function setActiveLangNoRerender(lang) {
    ElstrLanguage.setActiveLangNoRerender(lang).then();
}
exports.setActiveLangNoRerender = setActiveLangNoRerender;
/**
 * This is the class for Language used in Elstr projects (JSON data strings)
 *
 * @class ElstrLanguage
 */
var ElstrLanguage = /** @class */ (function () {
    function ElstrLanguage(reRender) {
        ElstrLanguage.reRender = reRender;
        var _languageExists = ElstrApplicationData_1.languageExists();
        ElstrLanguage._activeLang = _languageExists
            ? window.ELSTR.applicationData.language.current
            : "de";
        ElstrLanguage.translations = _languageExists
            ? window.ELSTR.applicationData.language.translations
            : {};
        ElstrLanguage.updateHtmlLang();
        // Delete data from window object
        if (_languageExists) {
            window.ELSTR.applicationData.language = null;
        }
    }
    Object.defineProperty(ElstrLanguage, "activeLang", {
        get: function () {
            return this._activeLang;
        },
        enumerable: true,
        configurable: true
    });
    ElstrLanguage.prototype.disableErrors = function () {
        ElstrLanguage.showErrors = false;
    };
    ElstrLanguage.setActiveLang = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ElstrLanguage.handleSetActiveLang(lang)];
                    case 1:
                        _a.sent();
                        ElstrLanguage.reRender();
                        return [2 /*return*/];
                }
            });
        });
    };
    ElstrLanguage.setActiveLangNoRerender = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ElstrLanguage.handleSetActiveLang(lang)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ElstrLanguage.setTranslations = function (translations) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                ElstrLanguage.translations = translations;
                return [2 /*return*/];
            });
        });
    };
    ElstrLanguage.handleSetActiveLang = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ElstrLanguage.loadLanguageFromService(lang)];
                    case 1:
                        _a.sent();
                        ElstrLanguage.updateHtmlLang();
                        return [2 /*return*/];
                }
            });
        });
    };
    ElstrLanguage.getTranslations = function () {
        return ElstrLanguage.translations;
    };
    ElstrLanguage.loadLanguageFromService = function (langCode) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var oldLang, _c, result, e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        oldLang = ElstrLanguage._activeLang;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 7]);
                        ElstrLanguage._activeLang = langCode;
                        if (!(ElstrBaseApp_1.default.ELSTR_BACKEND_VERSION === BackendVersion_1.ELSTR_BACKEND_VERSION.BE1)) return [3 /*break*/, 3];
                        _c = ElstrLanguage;
                        return [4 /*yield*/, ElstrLanguageService_1.default.load(langCode)];
                    case 2:
                        _c.translations = _d.sent();
                        _d.label = 3;
                    case 3:
                        if (!(ElstrBaseApp_1.default.ELSTR_BACKEND_VERSION === BackendVersion_1.ELSTR_BACKEND_VERSION.BE2)) return [3 /*break*/, 5];
                        return [4 /*yield*/, ElstrLanguageService_2.default.getAllMessages()];
                    case 4:
                        result = _d.sent();
                        ElstrLanguage.translations = ((_b = (_a = result) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.messages) || {};
                        _d.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _d.sent();
                        console.group("Setting new Language");
                        console.error("new language could not be set.");
                        ElstrLanguage._activeLang = oldLang;
                        console.error("oldLang remains activeLang.");
                        console.info("server msg is:");
                        console.error(e_1);
                        console.groupEnd();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ElstrLanguage.updateHtmlLang = function () {
        document.documentElement.lang = ElstrLanguage._activeLang;
    };
    ElstrLanguage.showErrors = true;
    return ElstrLanguage;
}());
exports.default = ElstrLanguage;
//# sourceMappingURL=ElstrLanguage.js.map